import { MODELS } from "config/constants";
import { ModelTypes, ThreatModel } from "types";

const DEFAULT_THRESHOLDS = [5, 5, 5, 5, 5, 5];

export function getSiteThresholds(threats?: ThreatModel[]): number[] {
  const site = threats?.[0]?.box?.site;
  if (!site) return DEFAULT_THRESHOLDS;
  return [
    site.zoneST || 0,
    site.gestureST || 0,
    site.passedOutST || 0,
    site.fightST || 0,
    site.weaponST || 0,
    site.abusiveST || 0
  ];
}

export function getModelCounts(threats?: ThreatModel[]): number[] {
  const counts = MODELS.map(() => 0);
  threats?.forEach((threat) => {
    const idx = MODELS.indexOf((threat as any)?.threatType?.model as ModelTypes);
    if (idx >= 0) counts[idx] += 1;
  });
  return counts;
}

export function getThresholdPercent(count: number, threshold: number): number {
  if (count && threshold) {
    const res = (count / threshold) * 100;
    return Math.round(Math.min(100, Math.max(0, res)));
  }
  if (count) return Math.round(Math.min(100, Math.max(0, count)));
  return 0;
}

export function getThresholdSeries(threats?: ThreatModel[], models: ModelTypes[] = MODELS): number[] {
  const counts = getModelCounts(threats);
  const thresholds = getSiteThresholds(threats);
  return models.map((model) => {
    const i = MODELS.indexOf(model);
    return getThresholdPercent(counts[i] || 0, thresholds[i]);
  });
}

export function getThresholdPercentForLevel(threats: ThreatModel[] | undefined, level: number): number {
  const counts = getModelCounts(threats);
  const thresholds = getSiteThresholds(threats);
  return getThresholdPercent(counts[level] || 0, thresholds[level]);
}
